import * as React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import styles from './styles.module.styl';
var windowExists = typeof window !== 'undefined';
var ENV = windowExists ? window.env.NODE_ENV : process.env.NODE_ENV;
export var EditLink = function (_a) {
    var contentfulId = _a.contentfulId, githubEditLink = _a.githubEditLink, trackData = _a.trackData;
    var t = useTranslation('core').t;
    var content;
    // Removing locale from the Article id
    var cleanedContentfulId = contentfulId === null || contentfulId === void 0 ? void 0 : contentfulId.replace(/-[a-z]{2}-[a-z]{2}$/i, '');
    if (contentfulId && ENV !== 'production') {
        content = (React.createElement(React.Fragment, null,
            React.createElement("span", null,
                t('articleFooter.feedbackSection.editLink.suggestionText', 'Any suggestion or typo?'),
                " "),
            React.createElement("a", { className: styles.editLink, href: "https://app.contentful.com/spaces/cdy7uua7fh8z/entries/".concat(cleanedContentfulId), onClick: function () { return trackData('click:edit-contentful'); }, target: "_blank", rel: "noreferrer noopener nofollow" }, t('articleFooter.feedbackSection.editLink.editOnContentful', 'Edit on Contentful'))));
    }
    else if (githubEditLink) {
        content = (React.createElement(React.Fragment, null,
            React.createElement("span", null,
                t('articleFooter.feedbackSection.editLink.suggestionText', 'Any suggestion or typo?'),
                " "),
            React.createElement("a", { className: styles.editLink, href: githubEditLink, onClick: function () { return trackData('click:edit-github'); }, target: "_blank", rel: "noreferrer noopener nofollow" }, t('articleFooter.feedbackSection.editLink.editOnGitHub', 'Edit on GitHub'))));
    }
    return React.createElement("div", { className: styles.suggestions }, content);
};
